import React, { useCallback } from 'react';
import cx from 'classnames';
import { MultiSelectContext } from './MultiSelectContext';
import styles from './MultiSelect.module.css';
const MultiSelect = ({ name, selectedValues, className, children, onChange }) => {
    const handleChange = useCallback(({ target: { value } }) => onChange(selectedValues.includes(value)
        ? selectedValues.filter((val) => val !== value)
        : [...selectedValues, value]), [selectedValues, onChange]);
    return (React.createElement("ul", { className: cx(styles.component, className) },
        React.createElement(MultiSelectContext.Provider, { value: { name, selectedValues, onChange: handleChange } }, children)));
};
export default MultiSelect;
//# sourceMappingURL=MultiSelect.js.map